import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../utility";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import Loader from "../../common/Loader";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditStaff = () => {
    const [isChecked, setIsChecked] = useState(true);

    const {id} = useParams();

    const navigate = useNavigate();

    const [flag, setFlag] = useState(2);
    const [staffDetail, setStaffDetail] = useState(null);
    const [loading, setLoading] = useState(true);

    const {register, handleSubmit, reset, formState: {errors}} = useForm();
    
    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/staff/viewStaff/${id}`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("staff Detail res : ", res);
            setStaffDetail(res?.data?.staff);
            setIsChecked(res?.data?.staff?.staff_status === "1" ? true : false);
            reset({max_fund: res?.data?.staff?.max_fund, volta: res?.data?.staff?.volta, registration_no: res?.data?.staff?.registration_no, color_desc: res?.data?.staff?.color_desc, model: res?.data?.staff?.model, vin_id: res?.data?.staff?.vin_id, rfid_no: res?.data?.staff?.rfid_no})
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("staff detail error : ", err);
        })
    }, [flag])

    const onSubmit = (data) => {
        setLoading(true);
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.post(`${API_URL}/user/staff/edit`, {...data, staff_id: staffDetail?.id, staff_status: isChecked ? "1" : "0"}, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("staff Edit res : ", res);
            toast.success("VCard Updated Successfully.");
            setTimeout(() => {
                navigate('/vcards');
            }, 2200)
            setLoading(false);
        }).catch((err) => {
            if(err?.response?.data?.error){
                toast.error(err?.response?.data?.error?.registration_no ? 
                    err?.response?.data?.error?.registration_no[0] : err?.response?.data?.error?.color_desc ?
                    err?.response?.data?.error?.color_desc[0] : err?.response?.data?.error?.model ?
                    err?.response?.data?.error?.model[0] : "Error in updating VCard.");
            } else {
                toast.error("Error in updating Vcard")
            }
            setLoading(false);
            console.log("staff Edit error : ", err);
        })
    }

    
    return (
        <div className="staff-detail-page">
            <ToastContainer />
            {loading ? (
                <Loader />
            ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* <h1 className="staffdetail-t1">{staffDetail?.staff_account}</h1> */}
                    <h1 className="staffRegNumber">{staffDetail?.registration_no ? staffDetail?.registration_no.split(',')[0] : "N/A" }</h1>
                    <h6 className="breadCrumbs mt-4 pb-3"> 
                        <span className="pointer" onClick={() => navigate('/vcards')}>VCards</span> 
                        {/* <span className="greater-than"> &#62; </span> 
                        {staffDetail?.staff_account}  */}
                        <span className="greater-than"> &#62; </span> 
                        <span className="viewVCardText">Edit</span>
                    </h6>
                    <h3 className="staffdetail-sub-heading mt-4">Information</h3>
                    <div className="d-flex pt-2">
                        <div className="divEditLeft d-flex flex-column">
                            <p className="displayBlockText">Status</p>
                            {/* <p className="displayBlockText">Staff account</p> */}
                            {/* <p className="displayBlockText">Wallet</p> */}
                            {/* <p className="displayBlockText">Name - Surname</p> */}
                            {/* <p className="displayBlockText">Address</p> */}
                            {/* <p className="displayBlockText">Email</p> */}
                            {/* <p className="displayBlockText">Phone</p> */}
                            <p className="displayBlockText">V-Card</p>
                            <p className="displayBlockText">Registration Number</p>
                            <p className="displayBlockText">Color</p>
                            <p className="displayBlockText">Model</p>
                            <p className="displayBlockText">VIN</p>
                            <p className="displayBlockText">RFID</p>
                            <p className="displayBlockText">VID</p>
                            <p className="displayBlockText">Max Fund</p>
                        </div>
                        <div className="divEditRight d-flex flex-column">
                            <p className="displayBlockText">
                                <div className='switch-btn-div d-flex align-items-center'>
                                    <input id="switch-status" type="checkbox" 
                                        onChange={(e) => {setIsChecked(e.target.checked);}} 
                                        defaultChecked={isChecked}  
                                        name="check" 
                                        value={true} 
                                        class="toggle-station"/>                            
                                    <label for="switch-status" 
                                        className={isChecked ? "switch-active-label" 
                                        : "switch-active-label swith-off"}>
                                        {isChecked? 'Enable' : 'Disable'}
                                    </label>
                                </div>
                            </p>
                            <p className="displayBlockText text-bold "><input type="text" value={staffDetail?.staff_vcard} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            {/* <p className="displayBlockText">Angleria Horgan</p> */}
                            {/* <p className="displayBlockText">6658 Ladpao Road Jungrasem Jatujak Bangkok 10900</p> */}
                            {/* <p className="displayBlockText">angleria_2539@gmail.com</p> */}
                            <p className="displayBlockText"><input type="text" {...register("registration_no")} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("color_desc")} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("model")} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("vin_id")} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("rfid_no")} disabled className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("volta")} disabled className="searchBox h-75" style={{ width: '350px'}}/></p>
                            <p className="displayBlockText"><input type="text" {...register("max_fund")} className="searchBox h-75" style={{ width: '350px'}}/></p>
                            
                        </div>
                    </div>
                    <div className="d-flex mt-4 mb-4">
                        <button className="pointerButton px-5">Submit</button>
                        <button className="secondaryPointerButton ms-4 px-5" onClick={() => navigate('/vcards')}>Cancel</button>
                    </div>
                </form>
            )}
        </div>
    )
}

export default EditStaff;